module.exports = __webpack_public_path__ + "static/media/art-collections-icon.8d74fddc.svg";